export default __webpack_public_path__ + "assets/ee5d07306df9048ed8de9d5bf83f5254.png";